import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';

import { IBetslipRootState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipBetBuilderPick } from '../../../../../core/picks/betslip-bet-builder-pick';
import { SlipId } from '../../../../bet-generation/models';
import BetslipPickActions from '../../../../picks/actions';
import { RemoveButtonStyle } from '../../../../picks/components/digital/pick-remove-button/remove-button-style';
import BetslipPickUtilsService from '../../../../picks/services/betslip-pick-utils.service';
import { RewardTokenContext } from '../../../../reward-tokens/reward-tokens.model';
import { EntainUiBetBuilderPickRemovalTracking } from '../../../../tracking/tracking.models';
import { BetBuilderPick } from '../../../models';

@Component({
    selector: 'bs-linear-bet-builder-pick',
    templateUrl: './linear-bet-builder-pick.component.html',
    styleUrls: ['./linear-bet-builder-pick.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderPickComponent implements OnChanges {
    @Input() pick: BetBuilderPick;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() removeButtonStyle: RemoveButtonStyle;

    tokenContext: RewardTokenContext;

    // Combo because the selection checkbox should target Combo Bet State
    betslipType = BetslipType.Combo;

    slipId: SlipId;

    constructor(
        private store: Store<IBetslipRootState>,
        private betslipPickUtilsService: BetslipPickUtilsService,
    ) {}

    ngOnChanges(): void {
        const currentPickId = this.tokenContext?.pickId;

        const newPick = this.pick;
        const newPickId = newPick?.id;

        if (!newPickId || (currentPickId && newPickId.isEqual(currentPickId))) {
            return;
        }

        this.tokenContext = {
            betslipType: BetslipType.BetBuilder,
            pickId: newPickId,
        };
    }

    removePick(): void {
        if (BetslipBetBuilderPick.isEntainUiBetBuilderPick(this.pick)) {
            this.betslipPickUtilsService.trackEntainUiBetBuilderPickRemoval(EntainUiBetBuilderPickRemovalTracking.TrackingAllPickRemovalSgp);
        } else {
            this.betslipPickUtilsService.trackNonSgpPickRemoval(EntainUiBetBuilderPickRemovalTracking.TrackingSinglePickRemoval);
        }

        this.store.dispatch(BetslipPickActions.requestRemovePick({ pickId: this.pick.id }));
    }
}
